import { useMutation, useQueryClient } from '@tanstack/react-query';
import useToast from '../useToast';
import { deleteOrganizationContext } from '@/services/api/requests/super-admin';
import { TCustomAxiosError } from '@/services/api';
import queryKeys from '@/constants/queryKeys';

const useClearOrganizationContext = () => {
  const toast = useToast();
  const queryClient = useQueryClient();

  const { mutate, isPending, error, isSuccess } = useMutation({
    mutationFn: async () => {
      await deleteOrganizationContext();
    },
    onSuccess: () => {
      // Drop the cached context now so the viewing-mode modal closes before the reload.
      queryClient.setQueryData([queryKeys.superAdmin.currentOrganizationContext], null);

      toast({
        title: 'Organization Context Cleared',
        description: 'You have successfully cleared the organization context.',
        status: 'success',
      });

      setTimeout(() => {
        window.location.reload();
      }, 2000); // Optional: Delay to allow the toast to be seen before reloading
    },
    onError: (error: TCustomAxiosError) => {
      toast({
        title: 'Error Clearing Organization Context',
        description: error.errors?.[0]?.message || 'An unexpected error occurred.',
        status: 'error',
      });
    },
  });

  return {
    mutate,
    isPending,
    error,
    isSuccess,
  };
};

export default useClearOrganizationContext;
